.labelContainer {
  position: relative;
  display: flex;
  flex-direction: column;
}

.dot {
  position: relative;
  height: 16px;
  width: 16px;
  border-radius: var(--tuna-shape-radius-pill);
  margin-top: 8px;
  margin-bottom: 8px;
}

.noteLabel {
  font-size: var(--tuna-typography-fontSize-sm);
}
